import { render, staticRenderFns } from "./ToSubscribePaidMemberButton.vue?vue&type=template&id=60519206&"
import script from "./ToSubscribePaidMemberButton.vue?vue&type=script&lang=ts&"
export * from "./ToSubscribePaidMemberButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports